"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConsoleErrorService = function () {
  function ConsoleErrorService() {
    _classCallCheck(this, ConsoleErrorService);
  }

  _createClass(ConsoleErrorService, [{
    key: "notify",
    value: function notify(err) {
      // eslint-disable-line class-methods-use-this
      return Promise.resolve().then(function () {
        return console.error(err);
      }); // eslint-disable-line no-console
    }
  }]);

  return ConsoleErrorService;
}();

exports.default = ConsoleErrorService;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-console/lib/index.js
// module id = 1561
// module chunks = 1